import { useEffect, useState } from "react";
import axios from "axios";
import "./PackagesSection.css";

const PackagesSection = () => {
  const [packs, setPacks] = useState([]);

  useEffect(() => {
    fetchPacks();
  }, []);

  const fetchPacks = async () => {
    try {
      const res = await axios.get("https://vangal-backend.onrender.com/api/packs");
      setPacks(res.data);
    } catch (err) {
      console.error("Failed to load packs", err);
    }
  };

  return (
    <section className="vf-packs-section">
      <h2 className="vf-packs-title anim anim-top">AVAILABLE PACKS</h2>

      <div className="vf-packs-grid anim anim-bottom">
        {packs.map((p) => (
          <div className="vf-pack-card" key={p.id}>
            <div className="vf-pack-image-container">
              <img
                src={p.img}
                alt="Pack"
                className="vf-pack-image"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PackagesSection;
